import { authenticatedFetch } from "../utils/utils";

export const generateAiQcm = async (formData, isAdmin = false) => {
	var url = isAdmin ? `/super-admin-ai-qcm-generator/` : `/ai-qcm-generator/`;
	console.log(isAdmin);
	return await authenticatedFetch(url, {
		method: "POST",
		headers: {},
		body: formData
	})
		.then(res => res.json())
		.catch(error => {
			console.error(error);
			throw error;
		});
};
